export default class extends App.Entities.Search {
    constructor(Design) {
        super();
        this.Design = Design;
        this
            .setMode('mixer')
            .Observer
                .register(Design)
        ;
        Promise.all([
            App.Components.wait('.overview-filter'),
            // App.Components.wait('.js-mixer-order-search-or-tag'),
        ]).then(Helpers => {
            this.Component = Helpers.shift().setInterface(this); // .overview-filter
            // Helpers.shift().setInterface(this.Search); // .js-mixer-order-search-or-tag
            this.Component.update();
        });
    }
}
